import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  SharedService,
  environment,
  WhitelabelState,
  ClearCart,
  CartState,
  SweetAlertService,
  ClearAllVenueDatas,
  SetFutureDate,
  DeliveryState,
  FetchLocationList,
  ClearQRScannedDetails,
  SetAckrooPaymentDetails,
  SetSelectedCard,
  SetPaymentMethod,
  AnalyticsTrackingType,
  AppInitService,
  LocationSelectionAnalytics, 
  setAnalyticsData
} from '@moduurnv2/libs-orderingapp/src/core';
import { OrganizationLocationsBaseComponent } from '@moduurnv2/libs-orderingapp/src/features';

import { Store, Select } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import {
  SetSelectedLocation,
  LocationState,
  Location,
  FetchLocationDefaults,
  ClearFutureDate,
  ClearMenuList,
} from '@moduurnv2/libs-orderingapp/src';

import { Observable } from 'rxjs';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { FuturePickerComponent, } from '../../../shared';
import { ModalService } from '../../../shared/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {RoomUpdateSelectionComponent} from './../../../venue-management/components/room-update-selection/room-update-selection.component';
import { Plugins } from '@capacitor/core';
import { Config } from 'apps/orderingapp/web-orderingapp/src/config';
const { Geolocation } = Plugins;

@Component({
  selector: 'moduurnv2-organization-locations-desktop',
  templateUrl: './organization-locations-desktop.component.html',
  styleUrls: ['./organization-locations-desktop.component.scss'],
})
export class OrganizationLocationsDesktopComponent
  extends OrganizationLocationsBaseComponent
  implements OnInit {

  constructor(
    router: Router,
    sharedService: SharedService,
    store: Store,
    route: ActivatedRoute,
    sweetAlert: SweetAlertService,
    public translate: TranslateService,
    public httpresult: HttpClient,
    modal: ModalService
  ) {
    super(router, sharedService, store, route,sweetAlert, translate,httpresult,modal);
    let whiteLabel = this.store.selectSnapshot(WhitelabelState.getWhitelabel);
    this.unitOfDistance = whiteLabel.distance;
  }
  @Select(LocationState.getSelectedLocation) location$: Observable<Location>;
  unitOfDistance: string = 'miles';
  tickIcon:string = environment.image_basepath + environment.images.timeline_tick;
  getSelectedCoordinates() {
    let isRefinedLocation = localStorage.getItem('refinedLocation')
      ? JSON.parse(localStorage.getItem('refinedLocation'))
      : undefined;
    if (isRefinedLocation) {
      this.currLat = isRefinedLocation.coordinates[1];
      this.currLng = isRefinedLocation.coordinates[0];
    }
  }


  getLocation(selectedLng, selectedLat) {
    this.getSelectedCoordinates();
      Geolocation.getCurrentPosition()
        .then((position) => {
          alert(position)
          if (position) {
            this.currLat = position.coords.latitude;
            this.currLng = position.coords.longitude;
            this.getSelectedCoordinates();
            this.mapsSelector(
              this.currLat,
              this.currLng,
              selectedLng,
              selectedLat
            );
          }
        })
        .catch((error) => {
          this.mapsSelector(
            this.currLat,
            this.currLng,
            selectedLng,
            selectedLat
          );
        });
  }

  openPicker: boolean = false;
  @Input() location;
  @Input() isLocationOn: boolean;
  futureLocation;
  currLat: number;
  currLng: number;

  async orderFromOrganization(location, extraDetails?) {
    const selectedLocation = this.store.selectSnapshot(
      LocationState.getSelectedLocation
    );
    if (location.isLocationOpen) {
      if (selectedLocation && selectedLocation._id != location._id) {
        let selectedCart = this.store.selectSnapshot(CartState.getCart);
        if (selectedCart) {
          let vm = this;
          await this.sweetAlert
            .confirm(
              this.translate.instant('are-you-sure'),
              this.translate.instant('loc-change-clear-cart')
            )
            .then((choice) => {
              if (choice) {
                this.actionOnLocationSelection(location,extraDetails);
                this.store.dispatch(new ClearCart());
                this.store.dispatch(new ClearAllVenueDatas());  
                this.store.dispatch(new SetPaymentMethod({selectedPayment: null, selectedPaymentType: null}));              
              } else {
                return;
              }
            });
        } else {
          this.actionOnLocationSelection(location,extraDetails);
          this.store.dispatch(new ClearAllVenueDatas())
          this.store.dispatch(new ClearCart());
          this.store.dispatch(new SetPaymentMethod({selectedPayment: null, selectedPaymentType: null}));
        }
        
      } else {
        this.actionOnLocationSelection(location,extraDetails);
      }
    }
    if(!extraDetails || extraDetails?.primaryDeliveryTextCode != 'DELIVERYTYPE10'){
      this.store.dispatch(new ClearFutureDate());
    }
    this.store.dispatch(new ClearMenuList());
  }

  actionOnLocationSelection(location,extraDetails){
    this.store.dispatch(new SetSelectedLocation(location._id));
    this.store.dispatch(new FetchLocationDefaults(extraDetails));
    this.store.dispatch(new ClearQRScannedDetails());
    this.trackAnalyticsLocation(location, extraDetails);
    if(extraDetails?.primaryDeliveryTextCode == 'DELIVERYTYPE10'){
      this.showVenueRoomDeliveryPopup(location)
    } else {
      if(extraDetails)
      this.router.navigate([`locations/${location?._id}/home`]);
    }
  }

  trackAnalyticsLocation(location, extraDetails){
    if(location){
      const locationSelectionAnalytics: LocationSelectionAnalytics = { 
        _id: location?._id, 
        name: location?.name,
        analyticsTrackingType: AnalyticsTrackingType.LOCATION_SELECTION,
      };
    this.store.dispatch(new setAnalyticsData(locationSelectionAnalytics));
  }
  }

  showVenueRoomDeliveryPopup(location) {
    setTimeout(() =>
    this.modal.showMediumModalDesktop(RoomUpdateSelectionComponent, {
      whenClosed: (data) => {
      if (data) {
        this.router.navigate([`locations/${location._id}/home`]);
      }
    }})
    , 1000);
  }

  orderFromLocation(location){
    // this.store.dispatch(new FetchLocationList());// replace this by writing new api for subscribed location list
    // this.locationsList$.subscribe((response) => {
    //   if (response) {
    //     if(response.findIndex(locations => locations._id == location._id ) > -1){
    //     }
    //     else this.router.navigate([`/locations`]);
    // }
    // });
  

    // this.initService.load(Config.organizationId ,Config.appVersion).toPromise();

    if(location?.orderSettings?.asapOrder && location?.orderSettings?.futureOrder){
      const allowASAP = location.orderSettings.asapOrder.isAllow;
      const allowFuture = location.orderSettings.futureOrder.isAllow;
      const isLocationOpen = location.allow && location.isOpen;
      const locationDeliveryTypes = location.deliveryTypes;
      const selectedLocation = this.store.selectSnapshot(LocationState.getSelectedLocation);
      const selectedDelivery = this.store.selectSnapshot(DeliveryState.getSelectedDelivery);
      let extraDetails={};
      let isSelectedClassroomDelivery = this.validatingThePrimaryDeliveryType(locationDeliveryTypes,selectedLocation,location,selectedDelivery,'DELIVERYTYPE10');
      let isSelectedCurbsideDelivery = this.validatingThePrimaryDeliveryType(locationDeliveryTypes,selectedLocation,location,selectedDelivery,'DELIVERYTYPE07');
      
      if(isSelectedCurbsideDelivery)
        extraDetails['primaryDeliveryTextCode'] = 'DELIVERYTYPE07';


      if(isSelectedClassroomDelivery){
        extraDetails['primaryDeliveryTextCode'] = 'DELIVERYTYPE10'
        this.orderFromOrganization(location,extraDetails);
      } else if(allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location,extraDetails);
      } else if(allowASAP && allowFuture && isLocationOpen){
        this.orderNowFromLocation(location,extraDetails);
      } else if(!allowASAP && allowFuture && isLocationOpen){
        this.futureOrderFromOrganization(location,extraDetails);
      } else if(allowASAP && !allowFuture && isLocationOpen){
        this.orderNowFromLocation(location,extraDetails);
      } else if(!allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location,extraDetails);
      } else if(!allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location,extraDetails);
      } else if(allowASAP && !allowFuture && !isLocationOpen){
        this.orderNowFromLocation(location,extraDetails);
      } else{
        this.orderNowFromLocation(location,extraDetails);
      }      
    }
  }

  validatingThePrimaryDeliveryType(locationDeliveryTypes,selectedLocation,location,selectedDelivery, deliveryTextCodeToCheck){
    let result = false;
    if((locationDeliveryTypes?.length == 1 && locationDeliveryTypes[0].textCode == deliveryTextCodeToCheck) || (selectedLocation?._id == location._id && selectedDelivery?.textCode == deliveryTextCodeToCheck)){
      result = true;
    } else if(locationDeliveryTypes?.length > 1 && locationDeliveryTypes[0].textCode == deliveryTextCodeToCheck && (!selectedLocation || (selectedLocation?._id == location._id && selectedDelivery?.textCode == deliveryTextCodeToCheck))){
      result = true;
    } else if(locationDeliveryTypes?.length > 1 && locationDeliveryTypes[0].textCode == deliveryTextCodeToCheck && selectedLocation?._id != location._id){
      result = true;
    }
    return result;
  }

  orderNowFromLocation(location,extraDetails) {
    const futureData = {
      location: this.futureLocation,
      futureTime: null,
    };
    this.store.dispatch(new SetFutureDate(futureData));
    this.orderFromOrganization(location,extraDetails);
  }

  futureOrderFromOrganization(location,extraDetails) {
    this.futureLocation = location;
    this.modal.showFuture(FuturePickerComponent, {
      data: {
        orderSettings: location.orderSettings,
        locationName: location.name,
        location: location,
      },
      whenClosed: (data) => {
        if (data) {
          console.log("extraDetails",extraDetails);
          if(extraDetails && extraDetails.primaryDeliveryTextCode)
            data['primaryDeliveryTextCode']= extraDetails.primaryDeliveryTextCode
          this.orderFromOrganization(location, data);
        }
      },
    });
  }

  mapsSelector(currentLat, currentLng, selectedLng, selectedLat) {
    if (
      /* if we're on iOS, open in Apple Maps */
      navigator.platform.indexOf('iPhone') != -1 ||
      navigator.platform.indexOf('iPad') != -1 ||
      navigator.platform.indexOf('iPod') != -1
    ) {
      let url;
      if (currentLat != undefined && currentLng != undefined) {
        url = environment.mapbox.directionURLIOS +
        'saddr=' +
        currentLat +
        ',' +
        currentLng +
        '&daddr=' +
        selectedLat +
        ',' +
        selectedLng +
        '&amp;ll='


      } else {
        url =environment.mapbox.directionURLIOS +
        '&daddr=' +
        selectedLat +
        ',' +
        selectedLng +
        '&amp;ll=';

      }
      let newWin = window.open(url);
        if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
          this.sweetAlert.alertWarning(
            '',
            this.translate.instant('device-popup-blocker')
          );
        }



    } else {
      /* else use Google */
      let url;
      if (currentLat != undefined && currentLng != undefined) {
        url = environment.mapbox.directionURL +
        'saddr=' +
        currentLat +
        ',' +
        currentLng +
        '&daddr=' +
        selectedLat +
        ',' +
        selectedLng +
        '&amp;ll='


      } else {
        url =environment.mapbox.directionURL +
        '&daddr=' +
        selectedLat +
        ',' +
        selectedLng +
        '&amp;ll=';

      }
      let newWin = window.open(url);
        if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
          this.sweetAlert.alertWarning(
            '',
            this.translate.instant('device-popup-blocker')
          );
        }

    }
  }
  


  getPreparationTime(selectedLocation){
    let prepTime = selectedLocation.preprationTime.split('-'); // prepTime[0] = minPreparationTime , prepTime[1] = maxPreparationTime
    return (+prepTime[0] ? selectedLocation.preprationTime : `Less than ${+prepTime[1]}`)
  }
}
